export default __webpack_public_path__ + "static/media/element_45.1b2052bb.jpg";